import React from 'react';
import { motion } from 'framer-motion';
import { useAuthStore } from '../../stores/authStore';
import { CloudProviderLogos } from './CloudProviderLogos';
import { useTranslation } from '../../hooks/useTranslation';

interface CloudButtonProps {
  variant?: 'default' | 'welcome' | 'profile';
  className?: string;
  isNested?: boolean;
}

export const CloudButton: React.FC<CloudButtonProps> = ({ 
  variant = 'default',
  className = '',
  isNested = false
}) => {
  const openLoginModal = useAuthStore((state) => state.openLoginModal);
  const { t } = useTranslation();

  const content = (
    <>
      <CloudProviderLogos />
      <span className="ml-4">
        {variant === 'welcome' && t('auth.welcomeBar.signIn')}
        {variant === 'profile' && t('auth.signIn')}
        {variant === 'default' && t('auth.signIn')}
      </span>
    </>
  );

  if (isNested) {
    return (
      <div className={`group flex items-center px-5 py-2 text-sm font-medium
                 bg-black/5 hover:bg-black/10 rounded-full transition-all duration-300
                 text-gray-900 whitespace-nowrap ${className}`}>
        {content}
      </div>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      onClick={openLoginModal}
      className={`group flex items-center px-5 py-2 text-sm font-medium
                 bg-black/5 hover:bg-black/10 rounded-full transition-all duration-300
                 text-gray-900 whitespace-nowrap ${className}`}
    >
      {content}
    </motion.button>
  );
}; 